import { GET } from "constants/methods";

export function getNodes() {
  const url = `/v1/node_names`;
  return {
    method: GET,
    url,
  };
}
